export default __webpack_public_path__ + "static/main-continuous-integration-dc957dc82c0e20af3ba27c8d011d4f18.png";